import React from 'react';
import { History, Home, QrCode, Search } from 'lucide-react';
import type { MobileNav, MobileScreen } from '../../types/mobile';
const items: {
  key: MobileScreen;
  label: string;
  icon: typeof Home;
}[] = [{
  key: 'home',
  label: 'হোম',
  icon: Home
}, {
  key: 'search',
  label: 'খুঁজুন',
  icon: Search
}, {
  key: 'history',
  label: 'ইতিহাস',
  icon: History
}];
export function MobileBottomNav({
  nav
}: {
  nav: MobileNav;
}) {
  return <nav className="grid grid-cols-4 border-t border-border bg-white px-2 pb-3 pt-1.5" aria-label="প্রধান মেনু" data-id="element-197" data-mp="2p9j2j80fjb30">
      {items.map(({
      key,
      label,
      icon: Icon
    }) => {
      const on = nav.screen === key;
      return <button key={key} onClick={() => nav.reset(key)} aria-current={on ? 'page' : undefined} className={`flex flex-col items-center gap-0.5 text-[11px] font-medium ${on ? 'text-navy-800' : 'text-slate-400'}`} data-id="element-198" data-mp="2gcqux4clt2g1">
            <span className={`flex h-7 w-7 items-center justify-center rounded-md ${on ? 'bg-navy-50' : ''}`} data-id="element-199" data-mp="jhm3lo96qfp1">
              <Icon className="h-[18px] w-[18px]" data-id="element-200" data-mp="vy9dgs8afu8j" />
            </span>
            {label}
          </button>;
    })}
      <button onClick={() => nav.go('scanner')} className="flex flex-col items-center gap-0.5 text-[11px] font-medium text-bdgreen-700" data-id="element-201" data-mp="15pvy1f6in5ny">
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-bdgreen-600 text-white" data-id="element-202" data-mp="10ru6s6yxs01e">
          <QrCode className="h-4 w-4" data-id="element-203" data-mp="d1ztxpemabh5" />
        </span>
        স্ক্যান
      </button>
    </nav>;
}